// CSS
import '../scss/main.scss'
import factory from './utilities/factory';
import Header from './modules/Header';
import yamz from "yet-another-medium-zoom";


document.addEventListener('DOMContentLoaded', function() {
  var header = document.querySelectorAll('.header__nav')
  factory(Header, header);
  const $images = [...document.querySelectorAll("img, picture")];
  yamz.bind($images);
});

